import { Decimal } from 'decimal.js';
/**
 * Денежная арифметика.
 *
 * Все суммы считаются через Decimal, а не через обычные числа JavaScript.
 * Причина: 0.1 + 0.2 в JavaScript даёт 0.30000000000000004. На одной строке это
 * незаметно, на документе из 50 позиций итог разъезжается с расчётом контрагента
 * на копейки — и такой счёт бухгалтерия не примет.
 *
 * Округление — арифметическое (половина вверх), как принято в российском учёте.
 */
// Половина округляется вверх: 2.545 → 2.55
Decimal.set({ rounding: Decimal.ROUND_HALF_UP, precision: 30 });
/** Знаков после запятой в денежных суммах — копейки. */
export const MONEY_SCALE = 2;
/** Знаков в количестве. */
export const QUANTITY_SCALE = 3;
/** Знаков в цене за единицу. Бывают позиции с ценой в доли копейки. */
export const PRICE_SCALE = 4;
export function toDecimal(value) {
    return value instanceof Decimal ? value : new Decimal(value ?? 0);
}
/** Округлить до копеек. */
export function roundMoney(value) {
    return toDecimal(value).toDecimalPlaces(MONEY_SCALE, Decimal.ROUND_HALF_UP);
}
export function roundQuantity(value) {
    return toDecimal(value).toDecimalPlaces(QUANTITY_SCALE, Decimal.ROUND_HALF_UP);
}
export function roundPrice(value) {
    return toDecimal(value).toDecimalPlaces(PRICE_SCALE, Decimal.ROUND_HALF_UP);
}
/** Строка с двумя знаками для БД и XML: «1234.50». Разделитель — точка. */
export function moneyToString(value) {
    return roundMoney(value).toFixed(MONEY_SCALE);
}
/** Форматирование для печатных форм: «1 234,50». Разделитель — запятая, пробелы по тысячам. */
export function formatMoney(value) {
    const fixed = roundMoney(value).toFixed(MONEY_SCALE);
    const [whole = '0', fraction = '00'] = fixed.split('.');
    const sign = whole.startsWith('-') ? '-' : '';
    const digits = sign ? whole.slice(1) : whole;
    // Неразрывный пробел, чтобы число не переносилось в вёрстке А4
    const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return `${sign}${grouped},${fraction}`;
}
/**
 * Количество для печати: лишние нули убираются.
 * 5.000 → «5», 2.500 → «2,5»
 */
export function formatQuantity(value) {
    const rounded = roundQuantity(value);
    const fixed = rounded.toFixed(QUANTITY_SCALE);
    const trimmed = fixed.replace(/\.?0+$/, '');
    return trimmed.replace('.', ',');
}
export function sum(values) {
    return values.reduce((acc, v) => acc.plus(toDecimal(v)), new Decimal(0));
}
export { Decimal };
//# sourceMappingURL=money.js.map